// extracted by mini-css-extract-plugin
module.exports = {"item":"t5oZof","fullWidth":"rhP-CR","root":"Ckl138","autoMargin":"y9w4Io","row":"VaPFaM","column":"qqnaY5"};